import { useContext, useEffect, useState } from "react"
import { AuthContext } from "../context/UserContext"
import { useNavigate } from "react-router";
import { ref, get, getDatabase } from "firebase/database";

const AdminRoute = (props: any) => {
    const { children } = props;
    const navigate = useNavigate();
    const { user, loading } = useContext(AuthContext);
    const [isAdmin, setIsAdmin] = useState(false);

    useEffect(() => {
        if (!loading) {
            if (user) {
                const db = getDatabase();
                get(ref(db, "admins/" + user?.uid)).then((snapshot) => {
                    if (snapshot.val() === true) {
                        setIsAdmin(true);
                    } else {
                        navigate('/super-manager');
                    }
                })
                .catch(() => {
                    navigate('/super-manager');
                });
            } else {
                navigate('/super-manager');
            }
        }
    }, [user, loading])

    return (
        <>
            {isAdmin && children}
        </>
    )
}

export default AdminRoute
